import React, { useEffect, useState, useMemo } from "react";
import { Constants } from "@eagerdog/constants";
import { IScore, ICatScore } from "@eagerdog/interfaces";

import Dropdown, { IOption } from "src/components/Dropdown/Dropdown";
import Input from "src/components/Input/Input";

import "./CATResults.scss";

interface IProps {
  result: IScore;
  onChange(result: ICatScore): void;
}

type ICatScoreWithNotes = ICatScore & { notes?: string };

const CATResults: React.FC<IProps> = (props) => {
  const [result, setResult] = useState<IOption>({ id: Constants.cat_result.pass, value: "Pass" });
  const [notes, setNotes] = useState<string>("");
  const [loaded, setLoaded] = useState<boolean>(false);

  const resultOptions: IOption[] = useMemo(() => [
    { id: Constants.cat_result.pass, value: "Pass" },
    { id: Constants.cat_result.fail, value: "Fail" },
    { id: Constants.cat_result.abs, value: "Absent" }
  ], []);

  useEffect(() => {
    if (!loaded) {
      if (props.result && props.result.cat) {
        const { result_type } = props.result.cat;
        const existingNotes = (props.result.cat as ICatScoreWithNotes)?.notes;
        for (let ro in resultOptions) {
          if (resultOptions[ro].id === result_type) {
            setResult(resultOptions[ro]);
            break;
          }
        }
        setNotes(existingNotes || "");
      }
      setLoaded(true);
    }
  }, [loaded, props.result, resultOptions]);

  const emitChange = (nextResultId: string, nextNotes: string) => {
    const payload: ICatScoreWithNotes = {
      result_type: nextResultId,
    };
    const normalizedNotes = nextNotes?.trim();
    if (normalizedNotes) {
      payload.notes = normalizedNotes;
    }
    props.onChange(payload as ICatScore);
  };

  // Get the title plan from the score (stored during registration)
  const titlePlan = props.result?.plan_to_earn_title || "No";
  const isBrachycephalic = props.result?.is_brachycephalic ? "Yes" : "No";

  return (
    <div className="CATResults">
      {/* Result Dropdown */}
      <Dropdown 
        value={result} 
        label={"Result"} 
        onChange={(_e: any, value: IOption) => { 
          setResult(value); 
          emitChange(value.id, notes);
        }} 
        options={resultOptions} 
        placeholder="Select result" 
      />

      <Input
        type="text"
        label="Notes (optional)"
        placeholder="Add notes"
        value={notes}
        onChange={(e: any) => {
          const nextNotes = e.target.value;
          setNotes(nextNotes);
          emitChange(result.id, nextNotes);
        }}
      />
    </div>
  );
};

export default CATResults;

